import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {HttpClient, HttpHeaders} from '@angular/common/http';

import { environment } from '../../../../environments/environment';
import {AccountService} from "../../services";
import {User} from "../../models";
import {WorkTimeSummaryList} from "../model/workTimeSummaryList";

@Injectable({ providedIn: 'root' })
export class WorkTimeService {
    constructor(
        private router: Router,
        private http: HttpClient,
        private accountService: AccountService
    ) {

    }

    getByUserAndTimeSpan(user: User, fromDate: string, toDate: string) {
        return this.http.get<WorkTimeSummaryList>(`${environment.apiEndpoint}/v1/work-times/${user.id}/${fromDate}/${toDate}`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        });
    }

    getByUserIdAndTimeSpan(userId: string, fromDate: string, toDate: string) {
        return this.http.get<WorkTimeSummaryList>(`${environment.apiEndpoint}/v1/work-times/${userId}/${fromDate}/${toDate}`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        });
    }

    getForWorkersByTimespan(fromDate: string, toDate: string) {
        return this.http.get<WorkTimeSummaryList>(`${environment.apiEndpoint}/v1/work-times/by/worker/${fromDate}/${toDate}`, {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + this.accountService.userValue.token,
            }),
        });
    }
}
